import { addSurveyOperatorNote } from './addSurveyOperatorNote';
import { fetchServiceSurveys } from './fetchServiceSurveys';

export const serviceSurveyService = {
  addSurveyOperatorNote,
  fetchServiceSurveys,
};
